import styled from 'styled-components';
import { Container } from 'styled-bootstrap-grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation';
import { PageHead } from '../../components/head/head';

const ErrorWrapper = styled.div`
    text-align: center;
    margin-top: 3.75rem;
`;

const ErrorTitleWrapper = styled.div`
    margin: 40px 50px;
`;

const ErrorTitleH1 = styled.h1`
    font-size: 2em;
    margin: .67em 0;
    margin-bottom: 30px;
`;

const ErrorTitleH5 = styled.h5`
    font-size: 1.25rem;
    margin-bottom: .5rem;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
`;

const ErrorDescriptionWrapper = styled.div`
`;

const ErrorDescriptionTitle = styled.div`
    font-weight: 700;
    padding-bottom: 10px;
`;

const ErrorDescriptionList = styled.ul`
    text-align: justify;
    display: inline-block;
`;

const ErrorDescriptionListItem = styled.li`
    padding-bottom: 5px;
`;


const ErrorIcon = styled(FontAwesomeIcon)`
    border: 3px solid ${props => props.theme.colors.text.blue};
    border-radius: 50%;
    padding: 20px 20px;
    /* font-size: 70px; */
    width: 70px;
    height: 70px;
    color: ${props => props.theme.colors.text.blue};
`;

export function NotFound() {
    return (
        <PageHead pageTitle='Resourse not found | {{siteName}}'>
            <ErrorWrapper>
                <Container>
                    <ErrorIcon icon={faExclamation} />
                    <ErrorTitleWrapper>
                        <ErrorTitleH1>WELL THIS DOESN'T ROCK</ErrorTitleH1>
                        <ErrorTitleH5>We're sorry, the page can't be found.</ErrorTitleH5>
                    </ErrorTitleWrapper>
                    <ErrorDescriptionWrapper>
                        <ErrorDescriptionTitle>
                            Try one of these:
                        </ErrorDescriptionTitle>
                        <ErrorDescriptionList>
                            <ErrorDescriptionListItem>Check the address spelling and try again</ErrorDescriptionListItem>
                            <ErrorDescriptionListItem>Navigate elsewhere at the top of this page</ErrorDescriptionListItem>
                            <ErrorDescriptionListItem>Search the site at the top right of this page</ErrorDescriptionListItem>
                        </ErrorDescriptionList>
                    </ErrorDescriptionWrapper>
                </Container>
            </ErrorWrapper>
        </PageHead>
    )
}